import styled from "styled-components";

export const StyledContainer = styled.section`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;
